import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import {Journal} from "../interface/journal";

@Injectable({
  providedIn: 'root'
})
export class JournalService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/journal/${id}`);
  }
  getCollection(): Observable<Journal[]>{
    return this.http.get<Journal[]>(`${this.baseUrl}/get/journals`);
  }

  post(data: Journal): Observable<any>{
    return this.http.post<Journal>(`${this.baseUrl}/create/journal`, data);
  }

  put(id: number, data: Journal): Observable<any>{
    return this.http.put<Journal>(`${this.baseUrl}/edit/journal/${id}`, data);
  }

  delete(id: number): Observable<Journal>{
    return this.http.delete<Journal>(`${this.baseUrl}/delete/journal/` + id);
  }

  deleteMultiple(ids: number[]): Observable<Journal[]>{
    const options = {body: ids};
    return this.http.delete<Journal[]>(`${this.baseUrl}/delete/selected/journal`, options);
  }

}
